import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SubSink } from 'subsink';
import { AuthService } from 'src/app/air/modules/common/service/auth/auth.service';
import * as settings from 'src/app/air/modules/common/lib/air-api-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { StorageService } from 'src/app/air/modules/common/service/storage/storage.service';
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['../auth.component.scss'],
    standalone: false
})
export class ForgetPasswordComponent {
    private subscription = new SubSink();
    userForm: FormGroup;
    @ViewChild('email') emailInput: any;

    constructor(
        private authService: AuthService,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        private storageService: StorageService
    ) {
        this.userForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    get email() {
        return this.userForm.get('email');
    }

    ngOnInit(): void {}

    resetPassword() {
        this.subscription.unsubscribe();
        if (this.email.errors && this.email.errors.required) {
            this.messageService.add({
                key: 'emptyToster',
                severity: 'error',
                life: 10000,
                summary: 'Error Message',
                detail: 'Email is required!',
            });
            this.emailInput.nativeElement.focus();
            return;
        }
        if (this.email.errors && this.email.errors.email) {
            this.messageService.add({
                key: 'emptyToster',
                severity: 'error',
                life: 10000,
                summary: 'Error Message',
                detail: 'Please provide a valid email!',
            });
            this.emailInput.nativeElement.focus();
            return;
        }
        // this.authService
        //     .resendLink({ email: this.email.value })
        //     .then((res) => {
        //         console.log('success ' + res);
        //         this.messageService.add({
        //             key: 'emptyToster',
        //             severity: 'success',
        //             life: 10000,
        //             summary: 'Success Message',
        //             detail: 'Check Inbox, Email Sent !',
        //         });
        //         this.storageService.setItem('userEmail', this.email.value);
        //         this.authService.passwordResetConfirmNav();
        //         return;
        //     })
        //     .catch((err) => {
        //         console.log('error ' + err);
        //         this.messageService.add({
        //             key: 'emptyToster',
        //             severity: 'error',
        //             life: 10000,
        //             summary: 'error Message',
        //             detail: err.message,
        //         });
        //         return;
        //     });
        //#region observable
        // this.subscription.add(this.authService.resendLink({ email: this.email.value }).subscribe((data: any) => {
        //   if (data.status == 200) {
        //     this.storageService.setItem('userEmail', this.email.value);
        //     this.authService.passwordResetConfirmNav();
        //   }
        // }));
        //#endregion observable
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
